import { render, staticRenderFns } from "./BuyPaymentUnion.vue?vue&type=template&id=44962a87&scoped=true&"
import script from "./BuyPaymentUnion.vue?vue&type=script&lang=js&"
export * from "./BuyPaymentUnion.vue?vue&type=script&lang=js&"
import style0 from "./BuyPaymentUnion.vue?vue&type=style&index=0&id=44962a87&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44962a87",
  null
  
)

export default component.exports